import { render, staticRenderFns } from "./IncidentBanner.vue?vue&type=template&id=3b0ef6c6"
import script from "./IncidentBanner.vue?vue&type=script&lang=js"
export * from "./IncidentBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports